import {
  Infinity as InfinityIcon,
  BookOpen,
  MessageCircle,
  Bookmark,
  Users,
  Landmark,
} from 'lucide-react';

export const PASS_BENEFITS = [
  {
    icon: InfinityIcon,
    title: 'Read without limits.',
    body: 'Every word explained as you read — tap any word for an instant AI explanation, no daily cap.',
  },
  {
    glyph: 'あA',
    title: 'Read in any script.',
    body: 'Switch between Kanji, Hiragana, Katakana, Romaji, and English mid-sentence. Add furigana or an English gloss underneath, independently.',
  },
  {
    icon: BookOpen,
    title: 'Your vocabulary lights up the page.',
    body: "Words you've saved glow amber in the text as you read; saved kanji in blue. The more you learn, the more the page reflects it back.",
  },
  {
    icon: MessageCircle,
    title: 'Your literary companion.',
    body: "An AI that knows the book you're reading. Ask about the characters, the period, the author's intent. Always available.",
  },
  {
    icon: Bookmark,
    title: 'Save words as you go.',
    body: 'Every word and kanji you tap gets saved. Review with flashcards, build your vocabulary one book at a time.',
  },
  {
    icon: Users,
    title: 'Bookshelves and community.',
    body: 'Curate your own shelves, share them, and explore what the readers you follow are discovering.',
  },
  {
    icon: Landmark,
    title: 'A library worth supporting.',
    body: 'Your membership sustains the curation — new books added, rare works surfaced, the reading room growing.',
  },
];
